import com from '../../../../../comMapping.js'
export function getdata() {
	let obj = {
		headData: [{
				title: '数电票号码',
				prop: 'invoiceNumber',
				width: '200',
				issort: true,
			},
			{
				title: '赋码次数',
				prop: 'codeAssignmentCount',
				width: '120',
				issort: true,
				custom:true,
				align: "right"
			},
			{
				title: '发票类型',
				prop: 'invoiceType',
				width: '120',
				showFilter: true,
				custom: true,
				checkList: com.lqfplx.map(item => item.code),
				dataList: com.lqfplx
			},
			{
				title: '单据号',
				prop: 'docNo',
				width: '200',
				issort: true,
			},
			{
				title: '单据状态',
				prop: 'docStatus',
				width: '120',
				showFilter: true,
				custom: true,
				checkList: com.lqdjzt.map(item => item.code),
				dataList: com.lqdjzt
			},
			{
				title: '开票时间',
				prop: 'drawDate',
				width: '220',
				issort: true,
				showFilter: true,
				custom: true,
			},
			{
				title: '价税合计',
				prop: 'totalTax',
				width: '180',
				issort: true,
				AmountFormat: true,
				align: "right"
			},
			{
				title: '操作人',
				prop: 'operator',
				width: '120',
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 1,
			paginationkey: 0
		},
	}
	return obj
}
